import { Modal }              from '@widesk-ui/components/modal/Modal';
import { ModalProps }         from '@widesk-ui/components/modal/Modal';
import { Action }             from '@widesk-ui/components/ButtonActions';
import { EditOutlined }       from '@ant-design/icons';
import React                  from 'react';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import ApiModel               from '@widesk-core/models/ApiModel';
import uniqueId               from 'lodash/uniqueId';

type EditOptions = {
	modelName?: string;
	wizard?: boolean;
	hideModelName?: boolean;
	modalProps?: Partial<ModalProps> | ((model: InstanceType<any>) => Partial<ModalProps>),
	actionProps?: Partial<Action>;
};

type M = ApiModel & WithLocalizedLabel;

const actionEditModel = (
	model: M,
	form: React.ReactNode,
	options?: EditOptions,
): Action => {
	const label = `Modifier` + (options?.hideModelName ? '' : ` - ${options?.modelName || model.localize()}`);

	return {
		label,
		icon: <EditOutlined />,
		onClick: () => Modal.open({
			title: label,
			children: form,
			okButtonProps: {
				htmlType: 'submit',
				form: uniqueId(),
			},
			okText: 'Enregistrer',
			...(() => {
				// Suppression du footer de la modale (si on est dans un wizard) et largeur par défaut à 1000
				if (options?.wizard) return { footer: null, width: 1000 };
				return {};
			})(),
			...options?.modalProps,
		}),
		...options?.actionProps,
	};
};

export default actionEditModel;
